














import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

import { IInventoryAdvancePayment } from '@/models';
import { ISystemError } from '@/models/error/error.types';
import { setErrorFromAxiosError } from '@/utils/helpers';

export default mixins(Proxyable).extend({
  name: 'InventoryAdvancePaymentFinanceManagersPicker',

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    },
    externalErrorMessage: {
      type: String,
      default: () => ''
    }
  },

  data: () => ({
    loading: false,
    error: null as ISystemError | null
  }),

  computed: {
    ...mapGetters({
      financeManagers:
        'inventoryAdvancePayment/getInventoryAdvancePaymentFinanceManagers'
    }),

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.error) {
        errorList.push(this.error.message);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.error = null;
  },

  methods: {
    ...mapActions({
      fetchRequisitionFinanceManagers:
        'inventoryAdvancePayment/fetchRequisitionFinanceManagers'
    }),

    init() {
      this.loading = true;
      this.fetchRequisitionFinanceManagers(this.inventoryAdvancePayment.id)
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => (this.loading = false));
    }
  }
});
